import { render, staticRenderFns } from "./DecastSection.vue?vue&type=template&id=47cd147c&scoped=true&"
import script from "./DecastSection.vue?vue&type=script&lang=js&"
export * from "./DecastSection.vue?vue&type=script&lang=js&"
import style0 from "./DecastSection.vue?vue&type=style&index=0&id=47cd147c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cd147c",
  null
  
)

export default component.exports